import type { Traducao } from '../tipos';

/** Textos de `apreciacaoModais`. Preenchido pela tradução da área — ver ../README.md. */
export const apreciacaoModais: Traducao = {
  pt: {
    /** Rodapé de lista com busca, compartilhado pelos seletores de ativo e de apreciação. */
    lista: {
      mostrarMais: 'Mostrar mais ({{restantes}} restantes)',
      mostrarMenos: 'Mostrar menos',
      resultadoUm: '{{total}} resultado encontrado',
      resultadoVarios: '{{total}} resultados encontrados',
    },
    copiarDados: {
      titulo: 'Copiar Dados da Máquina',
      instrucao:
        'Selecione outra apreciação para copiar todos os dados da etapa (informações da máquina, responsáveis, limites e fotos). Os dados atuais desta etapa serão substituídos.',
      buscaRotulo: 'Buscar apreciação',
      buscaPlaceholder: 'Título, número, máquina, fabricante, TAG...',
      carregando: 'Carregando apreciações...',
      vazioBusca: 'Nenhuma apreciação encontrada',
      vazioLista: 'Nenhuma outra apreciação disponível',
      semTitulo: 'Sem título',
      numero: 'Nº {{numero}}',
      tag: 'TAG: {{tag}}',
      erroCarregarSelecionada: 'Erro ao carregar dados da apreciação selecionada.',
    },
    selecionarAtivo: {
      titulo: 'Selecionar Ativo',
      metodoRotulo: 'Método de Busca',
      metodo: {
        equipamento: 'Nome do Equipamento',
        numeroPraxis: 'Nº APR Praxis',
        numeroAmt: 'Nº AMT',
        refSismana: 'Ref. Sismana',
      },
      buscarPor: 'Buscar por {{metodo}}',
      placeholder: {
        equipamento: 'Digite o nome do equipamento ou TAG...',
        numeroPraxis: 'Digite o número APR Praxis...',
        numeroAmt: 'Digite o número AMT...',
        refSismana: 'Digite a referência Sismana...',
        padrao: 'Digite para buscar...',
      },
      carregando: 'Carregando ativos...',
      vazioBusca: 'Nenhum ativo encontrado',
      vazioLista: 'Digite para buscar ativos',
      semNome: 'Sem nome',
      equipamento: 'Equipamento: {{equipamento}}',
      tag: 'TAG: {{tag}}',
    },
    criarTemplateParte: {
      titulo: 'Criar Template de Parte',
      parteRotulo: 'Parte:',
      aviso: 'Todos os riscos desta parte serão salvos como template.',
      nomeRotulo: 'Nome do Template',
      nomePlaceholder: 'Ex: Motor Elétrico - Parte 1',
      descricaoRotulo: 'Descrição (opcional)',
      descricaoPlaceholder: 'Descreva o template de parte...',
      botaoCriar: 'Criar Template',
      erroNomeObrigatorio: 'Nome do template é obrigatório',
      erroProjeto: 'Projeto não identificado',
      erroCriar: 'Erro ao criar template de parte',
    },
    criarTemplateMultiparte: {
      titulo: 'Criar Template Multiparte',
      completoRotulo: 'Template Completo:',
      completoValor: 'Todas as partes da apreciação',
      aviso: 'Todas as partes e riscos desta apreciação serão salvos como template.',
      nomeRotulo: 'Nome do Template',
      nomePlaceholder: 'Ex: Correia Transportadora - Completo',
      descricaoRotulo: 'Descrição (opcional)',
      descricaoPlaceholder: 'Descreva o template multiparte...',
      tipoMaquinaRotulo: 'Tipo de Máquina (opcional)',
      tipoMaquinaPlaceholder: 'Ex: Correia Transportadora, Prensa, etc.',
      grupoRotulo: 'Grupo (opcional)',
      grupoNenhum: 'Nenhum grupo',
      grupoAjuda: 'Organize seus templates em grupos para facilitar a busca',
      botaoCriar: 'Criar Template',
      erroNomeObrigatorio: 'Nome do template é obrigatório',
      erroProjeto: 'Projeto não identificado',
      erroCriar: 'Erro ao criar template multiparte',
    },
    selecionarTemplateParte: {
      titulo: 'Adicionar Parte de Template',
      buscaPlaceholder: 'Buscar template...',
      carregando: 'Carregando templates...',
      vazioBusca: 'Nenhum template encontrado',
      vazioLista: 'Nenhum template de parte disponível',
      riscos: '{{total}} risco(s)',
      criadoEm: 'Criado em {{data}}',
      botaoAplicar: 'Aplicar Template',
      aplicando: 'Aplicando...',
      erroSelecione: 'Selecione um template',
      erroCarregar: 'Erro ao carregar templates',
      erroCarregarPartes: 'Erro ao carregar templates de parte',
      erroAplicar: 'Erro ao aplicar template de parte',
    },
    selecionarTemplateMultiparte: {
      titulo: 'Adicionar de Template (Modelo/Tipo e Simples)',
      buscaPlaceholder: 'Buscar por nome, descrição, modelo/tipo...',
      filtroGrupoRotulo: 'Filtrar por Grupo',
      filtroGrupoTodos: 'Todos os grupos',
      avisoGrupoFiltrado: 'Templates simples ficam ocultos quando um grupo está filtrado.',
      filtroTipoRotulo: 'Filtrar por Tipo de Máquina',
      filtroTipoTodos: 'Todos os tipos',
      carregando: 'Carregando templates...',
      vazioFiltros: 'Nenhum template encontrado com os filtros aplicados',
      vazioLista: 'Nenhum template disponível',
      badgeMultiparte: 'Modelo Multiparte',
      badgeSimples: 'Template Simples',
      partes: '{{total}} parte(s)',
      riscos: '{{total}} risco(s)',
      criadoEm: 'Criado em {{data}}',
      partesTitulo: 'Partes do template selecionado',
      partesContador: '{{selecionadas}}/{{total}} selecionadas',
      carregandoPartes: 'Carregando partes...',
      semPartes: 'Este template não possui partes.',
      botaoAplicar: 'Aplicar Template',
      aplicando: 'Aplicando...',
      erroSelecione: 'Selecione um template',
      erroSelecioneParte: 'Selecione pelo menos uma parte para aplicar',
      erroCarregarMultiparte: 'Erro ao carregar templates multiparte',
      erroCarregarSimples: 'Erro ao carregar templates simples',
      erroCarregar: 'Erro ao carregar templates',
      erroAplicar: 'Erro ao aplicar template',
    },
    selecaoUsuario: {
      rotuloNomePadrao: 'Executante',
      crea: 'CREA',
      funcao: 'Função',
      cargo: 'Cargo',
      naoSelecionado: 'Não selecionado',
      usarUsuarioSistema: 'Usar usuário do sistema',
      usarDadosExternos: 'Usar dados externos',
      funcaoPlaceholder: 'Pode quebrar linha e colocar várias informações',
      carregandoUsuarios: 'Carregando usuários...',
      selecioneUsuario: 'Selecione um usuário...',
      semEmpresa: 'Selecione um projeto com empresa para ver usuários',
    },
    fotosCampo: {
      vazio: 'Nenhuma imagem de campo vinculada a esta apreciação.',
      usada: 'Usada',
      jaUsada: 'Já usada',
      analisada: 'Analisada',
      ampliarParaAnalisar: 'Ampliar para analisar',
      adicionada: 'Adicionada',
      adicionadaConfirmacao: 'Adicionada!',
      selecionarFoto: 'Selecionar esta foto',
      copiada: 'Copiada',
      copiadaConfirmacao: 'Copiada!',
      copiarImagem: 'Copiar imagem',
      copiarTitle: 'Copiar imagem (Ctrl+V para colar na parte)',
      fecharTitle: 'Fechar (Esc)',
      anteriorTitle: 'Anterior (←)',
      proximaTitle: 'Próxima (→)',
    },
    previewLatex: {
      titulo: 'Preview LaTeX',
      atualizando: 'Atualizando...',
      navegacaoTitle: 'Página inicial ao renderizar',
      navegacao: {
        primeira: '1ª página',
        sumario: 'Sumário',
        ultimaParte: 'Última parte editada',
        ultima: 'Última página',
      },
      exportarPdf: 'Exportar PDF',
      exportarPdfTitle: 'Exportar para PDF (LaTeX)',
      exportarWord: 'Exportar Word',
      exportarWordTitle: 'Exportar para Word (iLovePDF)',
      renderizar: 'Renderizar',
      renderizarTitle: 'Renderizar Documento',
      fecharTitle: 'Fechar Preview',
      erroRotulo: 'Erro:',
      semDadosRenderizar: 'Não há dados para renderizar.',
      semParteTitulo: 'Nenhuma parte adicionada',
      semParteTexto: 'Adicione partes à apreciação para visualizar o preview do PDF.',
      erroRenderizar: 'Erro ao renderizar PDF. Verifique se o LaTeX está instalado no servidor.',
      erroRenderizarTitulo: 'Erro ao Renderizar PDF',
      erroDesconhecido: 'Erro desconhecido',
      codigoLatex: 'Código LaTeX Gerado:',
      semDadosExportar: 'Não há dados para exportar.',
      confirmarWord: 'Gerando documento e convertendo para Word... Isso pode levar vários segundos. Continuar?',
      wordSucesso: 'Word gerado com sucesso!',
      erroExportarWord: 'Erro ao exportar Word.',
      erroExportarWordDetalhe: 'Erro ao exportar Word: {{mensagem}}',
      semPdfExportar: 'Não há PDF renderizado para exportar. Por favor, renderize o documento primeiro.',
      erroExportarPdf: 'Erro ao exportar PDF.',
    },
    editarParte: {
      nomeRotulo: 'Nome da Parte',
      nomePlaceholder: 'Digite o nome da parte',
      parentesesAviso: 'Atenção: Parênteses não estão balanceados',
      listaPlaceholder: 'Cole múltiplos itens separados por ; ou quebras de linha',
      statusPronta: 'Parte está pronta',
      botaoSalvar: 'Salvar Alterações',
      erroNomeObrigatorio: 'O campo "Nome da Parte" é obrigatório. Preencha o nome antes de salvar.',
      erroSalvar: 'Erro desconhecido ao salvar a parte. Verifique os campos e tente novamente.',
      painel: {
        abaFotos: 'Fotos do campo',
        abaPictogramas: 'Pictogramas',
        dica: 'Clique para adicionar ao próximo slot vazio.',
      },
      imagens: {
        titulo: 'Imagens da Parte (até 4 imagens)',
        slotRotulo: 'Imagem {{indice}}',
        slotAlt: 'Parte {{indice}}',
        analisarIA: 'Analisar com IA',
        analisarIATitle: 'Analisar riscos com IA',
        analisando: 'Analisando...',
        arrastarReordenar: 'Arraste para reordenar',
        dicaUpload: 'ou arraste e solte · Ctrl+V para colar · JPG, PNG, HEIC e outros',
        erroSemArquivo: 'Nenhum arquivo encontrado no arraste.',
        erroArquivoInvalido: 'Arquivo inválido. Arraste uma imagem (JPG, PNG, HEIC, etc.).',
        erroProcessar: 'Erro ao processar a imagem. Tente converter para JPG ou PNG antes de fazer upload.',
        erroSlotsCheios: 'Os 4 slots de imagem já estão preenchidos. Remova um para adicionar outro.',
        erroEmbutirFoto:
          'Não foi possível carregar essa foto para o PDF. Tente copiar/colar a imagem ou fazer upload pelo PC.',
      },
      cicloVida: {
        titulo: 'Ciclo de Vida',
        placeholder: 'Adicionar novo ciclo de vida',
        /** Rótulo por valor salvo no banco — o valor em si não muda de idioma. */
        opcao: {
          Ajuste: 'Ajuste',
          Limpeza: 'Limpeza',
          'Manutenção': 'Manutenção',
          'Operação Normal': 'Operação Normal',
        },
      },
      tiposPerigo: {
        titulo: 'Tipos de Perigo',
        selecioneRotulo: 'Selecione o tipo de perigo',
        /** Rótulo por valor salvo no banco — o valor em si não muda de idioma. */
        opcao: {
          'Mecânico': 'Mecânico',
          'Elétrico': 'Elétrico',
          'Térmico': 'Térmico',
          'Ruído': 'Ruído',
          'Vibração': 'Vibração',
          'Radiação': 'Radiação',
          'Químico': 'Químico',
          'Ergonômico': 'Ergonômico',
          Ambiental: 'Ambiental',
          'Combinação': 'Combinação',
        },
        eventoRotulo: 'Evento Perigoso',
        eventoPlaceholder: 'Ex: Lesão ocasionada pelo giro da placa',
        conformidadeRotulo: 'Status de Conformidade',
        conforme: 'Conforme',
        naoConforme: 'Não Conforme',
        outrosPerigos: 'Outros Perigos Encontrados',
        outrosPerigosComTipo: 'Outros Perigos Encontrados ({{tipo}})',
        adicionarPerigo: 'Adicionar outro perigo encontrado',
        semTipoPerigos: 'Selecione um tipo de perigo para ver os perigos específicos',
        consequencias: 'Potenciais Consequências',
        consequenciasComTipo: 'Potenciais Consequências ({{tipo}})',
        adicionarConsequencia: 'Adicionar outra consequência',
        semTipoConsequencias: 'Selecione um tipo de perigo para ver as potenciais consequências',
        partesCorpoRotulo: 'Partes do corpo a serem atingidas',
      },
      adequacoesTecnicas: {
        titulo: 'Adequações Técnicas',
        descricaoRotulo: 'Descrição da Condição Atual',
        medidasRotulo: 'Medidas de Controle',
        exigenciasRotulo: 'Exigências Normativas',
      },
      adequacoesAdministrativas: {
        titulo: 'Adequações Administrativas',
      },
      hrn: {
        exibirRotulo: 'Exibir valores de HRN no documento LaTeX',
        exibirAviso: '(As subseções de HRN não aparecerão no documento)',
        tituloAtual: 'HRN NA CONDIÇÃO ATUAL DA MÁQUINA',
        tituloFuturo: 'HRN APÓS CONDIÇÕES IMPLEMENTADAS',
        colRisco: 'Risco',
        colClassificacao: 'Classificação',
        riscoFallback: 'Risco {{numero}}',
        classificacao: {
          inaceitavel: 'Inaceitável',
          extremo: 'Extremo',
          muitoAlto: 'Muito alto',
          alto: 'Alto',
          significante: 'Significante',
          baixo: 'Baixo',
          muitoBaixo: 'Muito baixo',
          aceitavel: 'Aceitável',
        },
      },
      srpcs: {
        exibirRotulo: 'Exibir valores de SRP/CS no documento LaTeX',
        exibirAviso: '(A subseção de SRP/CS não aparecerá no documento)',
        titulo: 'SRP/CS: Sistema de Comando Relacionado à Segurança',
        severidadeRotulo: 'Severidade da Lesão',
        frequenciaRotulo: 'Frequência / Duração da Exposição',
        possibilidadeRotulo: 'Possibilidade de Evitar',
        categoriaRotulo: 'Categoria de Segurança',
        categoriasPossiveis: '(Possíveis: {{lista}})',
        naoRecomendado: ' (não recomendado)',
        plrRotulo: 'PLr (Performance Level required)',
        plrCalculado: 'Calculado: PLr {{plr}}',
        plrTitle: 'PLr calculado automaticamente baseado em S, F e P',
        silRotulo: 'SIL (Safety Integrity Level)',
        silCalculado: 'Calculado: SIL {{sil}}',
        silSemEquivalente: '(PL a não tem SIL equivalente)',
        silTitle: 'SIL calculado automaticamente baseado no PLr',
        silTitlePlA: 'PL a não tem SIL equivalente',
      },
      ia: {
        titulo: 'Análise de Riscos com IA',
        descricaoRotulo: 'Descrição da Máquina/Equipamento',
        descricaoPlaceholder:
          'Ex: Prensa hidráulica de 100 toneladas, utilizada para conformação de chapas metálicas. Operação manual com pedal...',
        descricaoAjuda: 'Forneça uma descrição detalhada da máquina para melhorar a precisão da análise.',
        dicaRotulo: 'Dica:',
        dicaTexto:
          'A IA analisará a imagem e preencherá automaticamente os campos de riscos, incluindo tipo de perigo, consequências, medidas de controle e valores HRN.',
        botaoAnalisar: 'Analisar',
        analisando: 'Analisando...',
        erroSemImagem: 'Por favor, faça upload de uma imagem da parte antes de analisar com IA.',
        erroSemDescricao: 'Por favor, forneça uma descrição da máquina para a análise.',
        concluida:
          'Análise concluída! {{total}} risco(s) identificado(s). Os campos foram preenchidos automaticamente. Revise e ajuste conforme necessário.',
        nenhumRisco:
          'Nenhum risco foi identificado na análise. Tente com uma imagem diferente ou verifique a descrição da máquina.',
        erroAnalisar: 'Erro ao analisar com IA: {{mensagem}}',
        erroDesconhecido: 'Erro desconhecido',
      },
    },
  },
  en: {
    lista: {
      mostrarMais: 'Show more ({{restantes}} remaining)',
      mostrarMenos: 'Show less',
      resultadoUm: '{{total}} result found',
      resultadoVarios: '{{total}} results found',
    },
    copiarDados: {
      titulo: 'Copy Machine Data',
      instrucao:
        'Select another assessment to copy every field on this step (machine details, people in charge, limits and photos). The current data on this step will be replaced.',
      buscaRotulo: 'Search assessment',
      buscaPlaceholder: 'Title, number, machine, manufacturer, TAG...',
      carregando: 'Loading assessments...',
      vazioBusca: 'No assessment found',
      vazioLista: 'No other assessment available',
      semTitulo: 'Untitled',
      numero: 'No. {{numero}}',
      tag: 'TAG: {{tag}}',
      erroCarregarSelecionada: 'Could not load the data of the selected assessment.',
    },
    selecionarAtivo: {
      titulo: 'Select Asset',
      metodoRotulo: 'Search Method',
      metodo: {
        equipamento: 'Equipment Name',
        numeroPraxis: 'Praxis APR No.',
        numeroAmt: 'AMT No.',
        refSismana: 'Sismana Ref.',
      },
      buscarPor: 'Search by {{metodo}}',
      placeholder: {
        equipamento: 'Type the equipment name or TAG...',
        numeroPraxis: 'Type the Praxis APR number...',
        numeroAmt: 'Type the AMT number...',
        refSismana: 'Type the Sismana reference...',
        padrao: 'Type to search...',
      },
      carregando: 'Loading assets...',
      vazioBusca: 'No asset found',
      vazioLista: 'Type to search assets',
      semNome: 'Unnamed',
      equipamento: 'Equipment: {{equipamento}}',
      tag: 'TAG: {{tag}}',
    },
    criarTemplateParte: {
      titulo: 'Create Part Template',
      parteRotulo: 'Part:',
      aviso: 'Every hazard of this part will be saved as a template.',
      nomeRotulo: 'Template Name',
      nomePlaceholder: 'E.g.: Electric Motor - Part 1',
      descricaoRotulo: 'Description (optional)',
      descricaoPlaceholder: 'Describe the part template...',
      botaoCriar: 'Create Template',
      erroNomeObrigatorio: 'Template name is required',
      erroProjeto: 'Project not identified',
      erroCriar: 'Could not create the part template',
    },
    criarTemplateMultiparte: {
      titulo: 'Create Multi-part Template',
      completoRotulo: 'Full Template:',
      completoValor: 'All parts of the assessment',
      aviso: 'Every part and hazard of this assessment will be saved as a template.',
      nomeRotulo: 'Template Name',
      nomePlaceholder: 'E.g.: Conveyor Belt - Full',
      descricaoRotulo: 'Description (optional)',
      descricaoPlaceholder: 'Describe the multi-part template...',
      tipoMaquinaRotulo: 'Machine Type (optional)',
      tipoMaquinaPlaceholder: 'E.g.: Conveyor Belt, Press, etc.',
      grupoRotulo: 'Group (optional)',
      grupoNenhum: 'No group',
      grupoAjuda: 'Organize your templates into groups to make them easier to find',
      botaoCriar: 'Create Template',
      erroNomeObrigatorio: 'Template name is required',
      erroProjeto: 'Project not identified',
      erroCriar: 'Could not create the multi-part template',
    },
    selecionarTemplateParte: {
      titulo: 'Add Part from Template',
      buscaPlaceholder: 'Search template...',
      carregando: 'Loading templates...',
      vazioBusca: 'No template found',
      vazioLista: 'No part template available',
      riscos: '{{total}} hazard(s)',
      criadoEm: 'Created on {{data}}',
      botaoAplicar: 'Apply Template',
      aplicando: 'Applying...',
      erroSelecione: 'Select a template',
      erroCarregar: 'Could not load the templates',
      erroCarregarPartes: 'Could not load the part templates',
      erroAplicar: 'Could not apply the part template',
    },
    selecionarTemplateMultiparte: {
      titulo: 'Add from Template (Model/Type and Simple)',
      buscaPlaceholder: 'Search by name, description, model/type...',
      filtroGrupoRotulo: 'Filter by Group',
      filtroGrupoTodos: 'All groups',
      avisoGrupoFiltrado: 'Simple templates are hidden while a group filter is applied.',
      filtroTipoRotulo: 'Filter by Machine Type',
      filtroTipoTodos: 'All types',
      carregando: 'Loading templates...',
      vazioFiltros: 'No template matches the applied filters',
      vazioLista: 'No template available',
      badgeMultiparte: 'Multi-part Model',
      badgeSimples: 'Simple Template',
      partes: '{{total}} part(s)',
      riscos: '{{total}} hazard(s)',
      criadoEm: 'Created on {{data}}',
      partesTitulo: 'Parts of the selected template',
      partesContador: '{{selecionadas}}/{{total}} selected',
      carregandoPartes: 'Loading parts...',
      semPartes: 'This template has no parts.',
      botaoAplicar: 'Apply Template',
      aplicando: 'Applying...',
      erroSelecione: 'Select a template',
      erroSelecioneParte: 'Select at least one part to apply',
      erroCarregarMultiparte: 'Could not load the multi-part templates',
      erroCarregarSimples: 'Could not load the simple templates',
      erroCarregar: 'Could not load the templates',
      erroAplicar: 'Could not apply the template',
    },
    selecaoUsuario: {
      rotuloNomePadrao: 'Performed by',
      crea: 'CREA',
      funcao: 'Role',
      cargo: 'Position',
      naoSelecionado: 'Not selected',
      usarUsuarioSistema: 'Use a system user',
      usarDadosExternos: 'Use external data',
      funcaoPlaceholder: 'You can break lines and add several details',
      carregandoUsuarios: 'Loading users...',
      selecioneUsuario: 'Select a user...',
      semEmpresa: 'Select a project with a company to see users',
    },
    fotosCampo: {
      vazio: 'No field image linked to this assessment.',
      usada: 'Used',
      jaUsada: 'Already used',
      analisada: 'Analyzed',
      ampliarParaAnalisar: 'Zoom in to analyze',
      adicionada: 'Added',
      adicionadaConfirmacao: 'Added!',
      selecionarFoto: 'Select this photo',
      copiada: 'Copied',
      copiadaConfirmacao: 'Copied!',
      copiarImagem: 'Copy image',
      copiarTitle: 'Copy image (Ctrl+V to paste into the part)',
      fecharTitle: 'Close (Esc)',
      anteriorTitle: 'Previous (←)',
      proximaTitle: 'Next (→)',
    },
    previewLatex: {
      titulo: 'LaTeX Preview',
      atualizando: 'Updating...',
      navegacaoTitle: 'Start page when rendering',
      navegacao: {
        primeira: '1st page',
        sumario: 'Table of contents',
        ultimaParte: 'Last edited part',
        ultima: 'Last page',
      },
      exportarPdf: 'Export PDF',
      exportarPdfTitle: 'Export to PDF (LaTeX)',
      exportarWord: 'Export Word',
      exportarWordTitle: 'Export to Word (iLovePDF)',
      renderizar: 'Render',
      renderizarTitle: 'Render Document',
      fecharTitle: 'Close Preview',
      erroRotulo: 'Error:',
      semDadosRenderizar: 'There is no data to render.',
      semParteTitulo: 'No part added',
      semParteTexto: 'Add parts to the assessment to see the PDF preview.',
      erroRenderizar: 'Could not render the PDF. Check whether LaTeX is installed on the server.',
      erroRenderizarTitulo: 'Could Not Render the PDF',
      erroDesconhecido: 'Unknown error',
      codigoLatex: 'Generated LaTeX Code:',
      semDadosExportar: 'There is no data to export.',
      confirmarWord: 'Generating the document and converting it to Word... This may take several seconds. Continue?',
      wordSucesso: 'Word file generated successfully!',
      erroExportarWord: 'Could not export to Word.',
      erroExportarWordDetalhe: 'Could not export to Word: {{mensagem}}',
      semPdfExportar: 'There is no rendered PDF to export. Please render the document first.',
      erroExportarPdf: 'Could not export the PDF.',
    },
    editarParte: {
      nomeRotulo: 'Part Name',
      nomePlaceholder: 'Type the part name',
      parentesesAviso: 'Warning: parentheses are not balanced',
      listaPlaceholder: 'Paste several items separated by ; or line breaks',
      statusPronta: 'Part is ready',
      botaoSalvar: 'Save Changes',
      erroNomeObrigatorio: 'The "Part Name" field is required. Fill in the name before saving.',
      erroSalvar: 'Unknown error while saving the part. Check the fields and try again.',
      painel: {
        abaFotos: 'Field photos',
        abaPictogramas: 'Pictograms',
        dica: 'Click to add to the next empty slot.',
      },
      imagens: {
        titulo: 'Part Images (up to 4 images)',
        slotRotulo: 'Image {{indice}}',
        slotAlt: 'Part {{indice}}',
        analisarIA: 'Analyze with AI',
        analisarIATitle: 'Analyze hazards with AI',
        analisando: 'Analyzing...',
        arrastarReordenar: 'Drag to reorder',
        dicaUpload: 'or drag and drop · Ctrl+V to paste · JPG, PNG, HEIC and others',
        erroSemArquivo: 'No file found in the drop.',
        erroArquivoInvalido: 'Invalid file. Drag an image (JPG, PNG, HEIC, etc.).',
        erroProcessar: 'Could not process the image. Try converting it to JPG or PNG before uploading.',
        erroSlotsCheios: 'All 4 image slots are already filled. Remove one to add another.',
        erroEmbutirFoto:
          'Could not load this photo into the PDF. Try copying/pasting the image or uploading it from your computer.',
      },
      cicloVida: {
        titulo: 'Life Cycle',
        placeholder: 'Add a new life cycle',
        opcao: {
          Ajuste: 'Setup',
          Limpeza: 'Cleaning',
          'Manutenção': 'Maintenance',
          'Operação Normal': 'Normal Operation',
        },
      },
      tiposPerigo: {
        titulo: 'Hazard Types',
        selecioneRotulo: 'Select the hazard type',
        opcao: {
          'Mecânico': 'Mechanical',
          'Elétrico': 'Electrical',
          'Térmico': 'Thermal',
          'Ruído': 'Noise',
          'Vibração': 'Vibration',
          'Radiação': 'Radiation',
          'Químico': 'Chemical',
          'Ergonômico': 'Ergonomic',
          Ambiental: 'Environmental',
          'Combinação': 'Combination',
        },
        eventoRotulo: 'Hazardous Event',
        eventoPlaceholder: 'E.g.: Injury caused by the chuck rotation',
        conformidadeRotulo: 'Compliance Status',
        conforme: 'Compliant',
        naoConforme: 'Non-compliant',
        outrosPerigos: 'Other Hazards Found',
        outrosPerigosComTipo: 'Other Hazards Found ({{tipo}})',
        adicionarPerigo: 'Add another hazard found',
        semTipoPerigos: 'Select a hazard type to see the specific hazards',
        consequencias: 'Potential Consequences',
        consequenciasComTipo: 'Potential Consequences ({{tipo}})',
        adicionarConsequencia: 'Add another consequence',
        semTipoConsequencias: 'Select a hazard type to see the potential consequences',
        partesCorpoRotulo: 'Body parts that may be affected',
      },
      adequacoesTecnicas: {
        titulo: 'Technical Corrective Actions',
        descricaoRotulo: 'Current Condition Description',
        medidasRotulo: 'Control Measures',
        exigenciasRotulo: 'Regulatory Requirements',
      },
      adequacoesAdministrativas: {
        titulo: 'Administrative Corrective Actions',
      },
      hrn: {
        exibirRotulo: 'Show HRN values in the LaTeX document',
        exibirAviso: '(The HRN subsections will not appear in the document)',
        tituloAtual: 'HRN IN THE CURRENT MACHINE CONDITION',
        tituloFuturo: 'HRN AFTER THE MEASURES ARE IMPLEMENTED',
        colRisco: 'Risk',
        colClassificacao: 'Rating',
        riscoFallback: 'Risk {{numero}}',
        classificacao: {
          inaceitavel: 'Unacceptable',
          extremo: 'Extreme',
          muitoAlto: 'Very high',
          alto: 'High',
          significante: 'Significant',
          baixo: 'Low',
          muitoBaixo: 'Very low',
          aceitavel: 'Acceptable',
        },
      },
      srpcs: {
        exibirRotulo: 'Show SRP/CS values in the LaTeX document',
        exibirAviso: '(The SRP/CS subsection will not appear in the document)',
        titulo: 'SRP/CS: Safety-Related Parts of Control Systems',
        severidadeRotulo: 'Severity of Injury',
        frequenciaRotulo: 'Frequency / Duration of Exposure',
        possibilidadeRotulo: 'Possibility of Avoidance',
        categoriaRotulo: 'Safety Category',
        categoriasPossiveis: '(Possible: {{lista}})',
        naoRecomendado: ' (not recommended)',
        plrRotulo: 'PLr (Performance Level required)',
        plrCalculado: 'Calculated: PLr {{plr}}',
        plrTitle: 'PLr calculated automatically from S, F and P',
        silRotulo: 'SIL (Safety Integrity Level)',
        silCalculado: 'Calculated: SIL {{sil}}',
        silSemEquivalente: '(PL a has no SIL equivalent)',
        silTitle: 'SIL calculated automatically from the PLr',
        silTitlePlA: 'PL a has no SIL equivalent',
      },
      ia: {
        titulo: 'AI Hazard Analysis',
        descricaoRotulo: 'Machine/Equipment Description',
        descricaoPlaceholder:
          'E.g.: 100-ton hydraulic press used to form metal sheets. Manual operation with a foot pedal...',
        descricaoAjuda: 'Give a detailed description of the machine to improve the accuracy of the analysis.',
        dicaRotulo: 'Tip:',
        dicaTexto:
          'The AI will analyze the image and fill in the hazard fields automatically, including hazard type, consequences, control measures and HRN values.',
        botaoAnalisar: 'Analyze',
        analisando: 'Analyzing...',
        erroSemImagem: 'Please upload an image of the part before analyzing with AI.',
        erroSemDescricao: 'Please provide a description of the machine for the analysis.',
        concluida:
          'Analysis complete! {{total}} hazard(s) identified. The fields were filled in automatically. Review and adjust as needed.',
        nenhumRisco:
          'No hazard was identified in the analysis. Try a different image or check the machine description.',
        erroAnalisar: 'Could not analyze with AI: {{mensagem}}',
        erroDesconhecido: 'Unknown error',
      },
    },
  },
};
